import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Eye, EyeOff } from "lucide-react";
import { api, formatApiError } from "@/lib/apiClient";

export default function AdminSections() {
  const [items, setItems] = useState([]);
  const load = () => api.get("/admin/sections").then((r) => setItems(r.data || []));
  useEffect(() => { load(); }, []);

  const update = async (sec, patch) => {
    const body = { ...sec, ...patch };
    delete body.id; delete body.created_at; delete body.updated_at;
    try { await api.put(`/admin/sections/${sec.key}`, body); load(); }
    catch (e) { toast.error(formatApiError(e)); }
  };

  return (
    <div data-testid="admin-sections" className="space-y-8">
      <header>
        <div className="text-[11px] uppercase tracking-[0.22em] text-brand-charcoal/55">Master Section Manager</div>
        <h1 className="editorial-h1 text-5xl mt-2">{items.length} sections.</h1>
        <p className="mt-3 text-sm text-brand-charcoal/65 max-w-2xl">Show, hide, rename and reorder every major section on the public site. The Home page reacts in real time.</p>
      </header>

      <div className="card-elevated overflow-hidden">
        <table className="w-full text-sm" data-testid="section-table">
          <thead className="text-left text-[11px] uppercase tracking-[0.22em] text-brand-charcoal/55">
            <tr className="border-b border-brand-line"><th className="p-4">Key</th><th className="p-4">Title</th><th className="p-4">Subtitle</th><th className="p-4">Order</th><th className="p-4">Visible</th></tr>
          </thead>
          <tbody>
            {items.map((s) => (
              <tr key={s.key} className="border-b border-brand-line last:border-0" data-testid={`section-${s.key}`}>
                <td className="p-4 font-mono text-xs">{s.key}</td>
                <td className="p-4"><input className="pp-input" value={s.title || ""} data-testid={`sec-title-${s.key}`} onChange={(e) => setItems(items.map((x) => x.key === s.key ? { ...x, title: e.target.value } : x))} onBlur={() => update(s, {})} /></td>
                <td className="p-4"><input className="pp-input" value={s.subtitle || ""} data-testid={`sec-sub-${s.key}`} onChange={(e) => setItems(items.map((x) => x.key === s.key ? { ...x, subtitle: e.target.value } : x))} onBlur={() => update(s, {})} /></td>
                <td className="p-4 w-24"><input type="number" className="pp-input" value={s.sort_order || 0} onChange={(e) => setItems(items.map((x) => x.key === s.key ? { ...x, sort_order: Number(e.target.value) || 0 } : x))} onBlur={() => update(s, {})} /></td>
                <td className="p-4">
                  <button data-testid={`sec-toggle-${s.key}`} onClick={() => update(s, { is_visible: !s.is_visible })} className={`btn-pill text-xs ${s.is_visible ? "btn-dark" : "btn-ghost border border-brand-line"}`}>{s.is_visible ? <><Eye size={12} /> Visible</> : <><EyeOff size={12} /> Hidden</>}</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
